import { AfterViewInit, Component, EventEmitter, HostListener, Input, Output, ViewEncapsulation } from '@angular/core';
import { TooltipPosition, TooltipPositionX, TooltipPositionY } from 'fc-ui-components';
import { BehaviorSubject } from 'rxjs';

export interface ShoppingCartLinkAlert {
    text: string;
    url: string;
}

export type ShoppingCartAlert = string | ShoppingCartLinkAlert;

@Component({
    selector: 'shopping-cart-accordion',
    templateUrl: './shopping-cart-accordion.component.html',
    styleUrls: ['./shopping-cart-accordion.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ShoppingCartAccordionComponent implements AfterViewInit {
    @Input() icon?: string;
    @Input() image?: string;
    @Input() title: string;
    @Input() itemInfo?: ItemInfo;
    @Input() alertMessages?: (ShoppingCartAlert | null)[];
    @Input() isParent = false;
    @Output() alertLinkClick = new EventEmitter<string>();
    isOpen = true;
    isTooltipVisible = new BehaviorSubject<boolean>(false);
    public tooltipPosition: TooltipPosition = {
        originX: TooltipPositionX.Center,
        originY: TooltipPositionY.Top
    };

    public displayMode: DisplayMode = DisplayMode.Desktop;

    toggle() {
        this.isOpen = !this.isOpen;
    }

    public get DisplayMode() {
        return DisplayMode;
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.setDisplayMode(event.target.innerWidth);
    }

    ngAfterViewInit() {
        this.setDisplayMode(window.innerWidth);
    }

    public isLinkAlert(alert: ShoppingCartAlert): alert is ShoppingCartLinkAlert {
        return typeof alert !== 'string';
    }

    public handleLinkClick(event: Event, url: string) {
        event.preventDefault();
        event.stopPropagation();
        this.alertLinkClick.emit(url);
    }

    private setDisplayMode(width: number) {
        if (width < 768) this.displayMode = DisplayMode.Mobile;
        else this.displayMode = DisplayMode.Desktop;
    }
}

interface ItemInfo {
    articles: string;
    quantity: string;
    rrp: string;
    pp: string;
}

export enum DisplayMode {
    Desktop = 'desktop',
    Mobile = 'mobile'
}
